import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { SkeletonCards, ErrorMessage, usePageMeta } from '../components/ui';
import MapCard from '../components/MapCard';

function MapsList() {
  usePageMeta({
    title: 'Brawl Stars Maps',
    description: 'Best brawlers for every Brawl Stars map and mode, ranked by win rate from tracked battles.',
  });
  const [maps, setMaps] = useState([]);
  const [modes, setModes] = useState([]);
  const [mode, setMode] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.getModes().then(setModes).catch(() => {});
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const data = await api.getMaps(mode || undefined);
        if (!cancelled) setMaps(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [mode]);

  return (
    <div className="page">
      <div className="wrap">
        <div className="phead">
          <div>
            <div className="eyebrow">Map intel</div>
            <h1>Maps</h1>
            <div className="sub">
              Every map in rotation, ranked by battle volume. Click a map for the top picks
              and a suggested draft.
            </div>
          </div>
        </div>

        <div className="filters">
          <div className="seg">
            <button className={mode === '' ? 'on' : ''} onClick={() => setMode('')}>All modes</button>
            {modes.map((m) => (
              <button key={m.mode} className={mode === m.mode ? 'on' : ''} onClick={() => setMode(m.mode)}>
                {m.mode}
              </button>
            ))}
          </div>
        </div>

        {error ? (
          <ErrorMessage message={error} />
        ) : loading ? (
          <SkeletonCards count={6} />
        ) : maps.length === 0 ? (
          <p className="empty-state">No maps found for this mode.</p>
        ) : (
          <div className="map-grid">
            {maps.map((m) => <MapCard key={`${m.map}-${m.mode}`} m={m} />)}
          </div>
        )}
      </div>
    </div>
  );
}

export default MapsList;
